import { render, staticRenderFns } from "./polling.vue?vue&type=template&id=e4f2e4ce&scoped=true"
import script from "./polling.vue?vue&type=script&lang=js"
export * from "./polling.vue?vue&type=script&lang=js"
import style0 from "./polling.vue?vue&type=style&index=0&id=e4f2e4ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f2e4ce",
  null
  
)

export default component.exports